import React from 'react';
import { CSSTransition, transit } from 'react-css-transition';
import { Table } from 'reactstrap';

import firework from '../images/1.gif';
import { AnimatedMobile } from './AnimatedMobile';
import { ShowWithDelay } from './ShowWithDelay';


const transitionStyles = {
    defaultStyle: {
        transform: "translate(100px, -600px)",
    },
    enterStyle: {
        transform: transit("translate(0px,  75px)", 2500, "ease-in-out"),
    },
    leaveStyle: {
        transform: transit("translate(100px, -600px)", 500, "ease-in-out"),
    },
    activeStyle: {
        transform: "translate(0px, 75px)",
    },
};
const transitionStyles2 = {
    defaultStyle: {
        transform: "translate(-200px, 1000px)",
        opacity: 0
    },
    enterStyle: {
        transform: transit("translate(0px,  75px)", 2000, "ease-in-out"),
    },
    leaveStyle: {
        transform: transit("translate(-200px, 1000px)", 500, "ease-in-out"),
        opacity: 0
    },
    activeStyle: {
        transform: "translate(0px, 75px)",

    },
};

const transitionStyles3 = {
    defaultStyle: {
        transform: "translate(0px, -600px)",
    },
    enterStyle: {
        transform: transit("translate(0px,  75px)", 1000, "ease-in-out"),
    },
    leaveStyle: {
        transform: transit("translate(0px, -600px)", 500, "ease-in-out"),
    },
    activeStyle: {
        transform: "translate(0px, 75px)",

    },
};

const transitionStyles4 = {
    defaultStyle: {
        transform: "translate(0px, -600px)",
    },
    enterStyle: {
        transform: transit("translate(0px,  75px)", 1000, "ease-in-out"),
    },
    leaveStyle: {
        transform: transit("translate(0px, -600px)", 500, "ease-in-out"),
    },
    activeStyle: {
        transform: "translate(0px, 75px)",

    },
};

const transitionStyles5 = {
    defaultStyle: {
        transform: "translate(-200px, 1000px)",
        opacity: 0
    },
    enterStyle: {
        transform: transit("translate(0px,  75px)", 4000, "ease-in-out"),
    },
    leaveStyle: {
        transform: transit("translate(-200px, 1000px)", 500, "ease-in-out"),
        opacity: 0
    },
    activeStyle: {
        transform: "translate(0px, 75px)",

    },
};

export class WinnerBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = { active: false };
        this.handleClick = this.handleClick.bind(this);
        this.onContinue = this.onContinue.bind(this);
    }

    componentDidMount() {
        this.handleClick();
    }

    onContinue() {
        this.handleClick();

        setTimeout(
            function () {
                if (typeof this.props.onCloseWinnerBox === "function") {
                    this.props.onCloseWinnerBox();
                }

            }
                .bind(this),
            500
        );
    }

    handleClick() {
        this.setState({ active: !this.state.active });



    }

    render() {

        var address = "/Images/" + this.props.prize.prizeImageUrl;

        return (
            <div className="container-fluid row">
                <div className="col-md-4">
                    <img src={firework} style={{ width: "80%", marginRight: "15%" }} alt="" />
                    <img src={firework} style={{ width: "80%", marginRight: "16%" }} alt="" />

                </div>

                <div className="col-md-4" style={{ height: "100%", overflow: "hidden" }}>
                    <CSSTransition {...transitionStyles} active={this.state.active}>

                        <div className="bg-primary" style={{ textAlign: "center", width: "100%", padding: "20px", fontSize: "30px" }} >
                            <h2 >
                                {"برنده " + traverse(this.props.prize.prizeRealName)}
                            </h2>
                        </div>


                    </CSSTransition>

                    <CSSTransition {...transitionStyles4} active={this.state.active}>

                    </CSSTransition>

                    <CSSTransition {...transitionStyles3} active={this.state.active}>
                        <img src={address} style={{ width: "100%" }} alt="" />
                    </CSSTransition>

                    <CSSTransition {...transitionStyles2} active={this.state.active}>

                        <Table>
                            <tbody>

                               <tr>
                                    <td><h3>ردیف قرعه کشی</h3> </td>
                                    <td><h2>{traverse(this.props.winner.chanceNumber).toString()}  </h2></td>
                                </tr>
                                <tr style={{width:"100%"}}>
                                    <td style={{width:"55%"}}><h3>کد قرعه کشی</h3></td>
                                    <td style={{width:"45%"}}><h2><AnimatedMobile number={(this.props.winner.uniqueId).toString()}></AnimatedMobile>  </h2></td>
                                </tr>

                            

                                <tr>
                                    <td><h3>شماره همراه</h3></td>
                                    <td><h2>
                                        <ShowWithDelay delay={5000}  number={traverse(mphone(this.props.winner.member.mobileNumber))}></ShowWithDelay>


                                    </h2></td>
                                </tr>

                            </tbody>

                        </Table>

                    </CSSTransition>


                    <CSSTransition {...transitionStyles5} active={this.state.active}>
                        <button onClick={this.onContinue} className="btn btn-primary" style={{ width: "100%" }}>ادامه</button>
                        <div className="text-center" style={{fontWeight:"bold"}}>
                            <br/>
                   
                        </div>
                    </CSSTransition>

                </div>
                <div className="col-md-4" >
                    <img src={firework} style={{ width: "80%", marginRight: "5%" }} alt="" />

                    <img src={firework} style={{ width: "80%", marginRight: "10%" }} alt="" />;



                </div>
            </div>
        );
    }
}
const persian = { 0: '۰', 1: '۱', 2: '۲', 3: '۳', 4: '۴', 5: '۵', 6: '۶', 7: '۷', 8: '۸', 9: '۹' };
function traverse(el) {
    el = el.toString();
    var list = el.match(/[0-9]/g);
    if (list !== null && list.length !== 0) {
        for (var i = 0; i < list.length; i++)
            el = el.replace(list[i], persian[list[i]]);
    }
    return el;


}
function mphone(v) {
    //var r = v.replace(/\D/g,"");
    var r = v.replace(/^(\d{3})(\d{3})(\d{4}).*/, '$3***$1');
    return r;
}



// WEBPACK FOOTER //
// ./src/elements/WinnerBox.js